// 筛选器管理
import http from "@/jslibs/axios/http";

// 筛选器列表
export const list = (data) => http.get("/v1/cms/GoodsFilter", data);

// 筛选器列表带了参数列表的
export const tree = (data) => http.get("/v1/cms/GoodsFilter/list", data);

// 筛选器新增
export const add = (data) => http.post("/v1/cms/GoodsFilter", data);

// 筛选器编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/GoodsFilter/${uuid}`, data);

// 筛选器删除
export const del = (data) => http.delete(`/v1/cms/GoodsFilter/${data.cuuid}`);

// 筛选器详情
export const detail = ({ cuuid, ...data }) => http.get(`/v1/cms/GoodsFilter/${cuuid}`, data);

// 添加参数
export const addItem = (data) => http.post(`/v1/cms/GoodsFilter/add_item`, data);

// 更新参数
export const editItem = ({ uuid, ...data }) => http.put(`/v1/cms/GoodsFilter/edit_item/${uuid}`, data);

// 删除参数
export const delItem = (data) => http.delete(`/v1/cms/GoodsFilter/del_item/${data.uuid}`);
